import { type MutableRefObject, useEffect } from 'react';

export default function useOnClickOutside(
  ref: MutableRefObject<HTMLElement | null>,
  handler: (e?: any) => void,
  isListenerStopped: boolean = false
) {
  useEffect(() => {
    const listener = (e: any) => {
      if (!ref?.current || ref.current.contains(e.target)) {
        return;
      }
      handler(e);
    };

    if (!isListenerStopped) {
      document.addEventListener('mousedown', listener);
    } else {
      document.removeEventListener('mousedown', listener);
    }

    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, handler, isListenerStopped]);
}
